<template>
  <div class="bundles-list">
    <h1 class="bundles-list__title">Bundles</h1>
    <div class="bundles-list__intro">
      Choose from one of our bundles to get a great deal on a certification voucher plus three
      months of training to prepare you for it!
    </div>
    <div class="bundles-list__plans">
      <template v-for="planBundle in planBundles">
        <PlanBundleItem :key="planBundle.plan.merchant_id" :plan="planBundle.plan" />
      </template>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CONSTANTS from '@/constants'
import PlanBundleItem from '@/components/plan-item-card/PlanBundleItem.vue'
import { routesRules } from '@/helpers/mixins'

export default {
  name: 'BundlesList',
  mixins: [routesRules],
  components: {
    PlanBundleItem,
  },
  data() {
    return {
      currentTemplate: 'individuals',
    }
  },
  computed: {
    ...mapState({
      availablePlans: state => state.products.availablePlans,
      certifications: state => state.products.availableCertifications,
    }),
    ...mapGetters({
      isBusinessUser: 'business/isBusinessUser',
      isBusinessPlanExpired: 'business/isBusinessPlanExpired',
    }),
    planBundles() {
      const { PLANS } = CONSTANTS
      const filterToApply = this.isBlackFridayPage
        ? [PLANS.EDA_PREMIUM, PLANS.EWPT_PREMIUM, PLANS.ECPPT_PREMIUM]
        : [
            PLANS.EWPTX_PREMIUM,
            PLANS.EJPT_FUNDAMENTALS,
            PLANS.EDA_PREMIUM,
            PLANS.EWPT_PREMIUM,
            PLANS.ECPPT_PREMIUM,
          ]
      const bundles = this.availablePlans
        .filter(plan => filterToApply.includes(plan.merchant_id))
        .map(plan => ({ plan }))

      return bundles
    },
  },
}
</script>

<style lang="scss" scoped>
.bundles-list {
  margin-bottom: 60px;
  &__title {
    font-size: rem(24px);
    line-height: rem(32px);
    font-style: normal;
    font-weight: 700;
    margin-bottom: 30px;
  }
  &__intro {
    color: var(--light-blue-gray);
    font-size: rem(18px);
    font-style: normal;
    font-weight: 450;
    line-height: rem(24px);
    margin-bottom: 50px;
  }
  &__plans {
    display: flex;
    flex-flow: column;
    row-gap: 25px;
  }
}
</style>
